export default __webpack_public_path__ + "static/media/congfooter.f3ea1858.png";